<mat-card appearance="outlined" class="mat-elevation-z1">
  <!-- Loaded View -->
  <ng-container *ngIf="isDataSetLoaded$ | async; else loading">
  <mat-card-title>
    <i class="pad-right"></i><b>{{cardTitle | translate | async }}</b>
    <div class="pull-right">
      <button mat-button title="Options" class="card-options-button" [matMenuTriggerFor]="helpOptions"><i class="fa fa-ellipsis-v fa-primary" style="font-size: 1.4em;"></i></button>
      <mat-menu #helpOptions="matMenu">
        <button mat-menu-item style="outline: none;" (click)="openHelpTextClicked()">{{ "Help" | translate : locale | async}}</button>
      </mat-menu>
    </div>
  </mat-card-title>
  <mat-card-content class="card-block target-card">
    <table>
      <tbody>
        <tr>
          <td>
            <div style="position: absolute; width: 99%; z-index: 0" [chart]="currentChart"></div>
            <span class="focus-metric-value">
              <b>{{primaryMetricValue}}</b>
              <i [ngClass]="[primaryMetricTrendArrow,primaryMetricTrendColor]"
                                        style="font-size: .9em;" class="pad-left"></i>
            </span>
            <br />
            <span class="focus-metric-label">{{primaryMetricName | translate : locale | async }}</span>
          </td>
        </tr>
      </tbody>
  </table>
  </mat-card-content>
  <mat-card-footer>
    <table>
      <tbody>
        <tr>
          <td *ngIf="!!leftMetricName">
            <span class="secondary-metric-value">
              <b>{{leftMetricValue}}</b>
              <span class="footer-chevron"><i [ngClass]="[leftMetricTrendArrow,leftMetricTrendColor]"></i></span>
            </span>
            <br />
            <span class="secondary-metric-label">
              {{leftMetricName | translate : locale | async }}
            </span>
          </td>
          <td *ngIf="!!centerMetricName">
            <span class="secondary-metric-value">
              <b>{{centerMetricValue}}</b>
              <span class="footer-chevron"><i [ngClass]="[centerMetricTrendArrow, centerMetricTrendColor]"></i></span>
            </span>
            <br />
            <span class="secondary-metric-label">
              {{centerMetricName | translate : locale | async }}
            </span>
          </td>
          <td *ngIf="!!rightMetricName">
            <span class="secondary-metric-value">
              <b>{{rightMetricValue}}</b>
              <span class="footer-chevron"><i [ngClass]="[rightMetricTrendArrow, rightMetricTrendColor]"></i></span>
            </span>
            <br />
            <span class="secondary-metric-label">
              {{rightMetricName | translate : locale | async }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card-footer>
</ng-container>

  <!-- Loading View with Pulse Animations -->
  <ng-template #loading>
    <mat-card-title>
        <div class="title-placeholder" syncPulse
            style="height: 24px; width: 150px; background-color: #e0e0e0; border-radius: 4px;"></div>
    </mat-card-title>

    <mat-card-content class="card-block target-card billboard" style="margin-bottom: 0px;">
        <div class="bs-flex-row" fxLayout="row">
            <div class="metric-container full-width-on-small">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <b class="metric-value">
                                    <span class="value-placeholder" syncPulse
                                        style="display: inline-block; width: 60%; height: 40px; background-color: #e0e0e0; border-radius: 4px;"></span>
                                </b>
                                <span class="icon-placeholder" syncPulse
                                    style="display: inline-block; width: 24px; height: 24px; background-color: #e0e0e0; border-radius: 50%; margin-left: 10px;"></span>
                            </td>
                        </tr>
                        <tr>
                            <td class="box-label" style="font-size: 1.2rem;">
                                <span class="subtitle-placeholder" syncPulse
                                    style="display: inline-block; width: 50%; height: 20px; background-color: #e0e0e0; border-radius: 4px;"></span>
                            </td>
                        </tr>
                        <tr>
                            <td class="box-label" style="font-size: 1.2rem;">
                                <span class="subtitle-placeholder" syncPulse
                                    style="display: inline-block; width: 60%; height: 20px; background-color: #e0e0e0; border-radius: 4px;"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="chart-container">
                <div class="chart-placeholder" syncPulse style="height: 130px; background-color: #e0e0e0; border-radius: 8px;"></div>
            </div>
        </div>
    </mat-card-content>

    <mat-card-footer class="billboard-seperator">
        <table style="width: 100%">
            <tbody>
                <tr>
                    <td style="width: 50%">
                        <span class="footer-placeholder" syncPulse
                            style="display: inline-block; width: 60%; height: 20px; background-color: #e0e0e0; border-radius: 4px;"></span>
                    </td>
                    <td style="width: 50%; text-align: right">
                        <span class="footer-placeholder" syncPulse
                            style="display: inline-block; width: 60%; height: 20px; background-color: #e0e0e0; border-radius: 4px;"></span>
                    </td>
                </tr>
            </tbody>
        </table>
    </mat-card-footer>
</ng-template>
</mat-card>
